import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Formik } from 'formik';
import { UsersContext } from '../../../contexts/UsersContext';
import { Grid, PageContainer } from '../../../layouts';
import UsersTable from './UsersTable';
import UsersFilterSection from './UsersFilterSection';
import { Groupbox } from '../../../components/Form';

const Users = (props) => {
  const { state, actions } = useContext(UsersContext);

  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    if (!state.users.length) {
      actions.getUsers();
    }
  }, [actions, state.users.length]);

  useEffect(() => {
    setFilteredUsers(state.users);
  }, [state.users, setFilteredUsers]);

  const onSearch = useCallback(
    (values) => {
      const newFilteredUsers = state.users.filter(
        (user) =>
          user.email.includes(values.email) &&
          (!values.onlyActive ||
            (values.onlyActive && user.status === 'active'))
      );
      setFilteredUsers(newFilteredUsers);
    },
    [state.users, setFilteredUsers]
  );

  return (
    <PageContainer component="main" maxWidth="md">
      <Grid container>
        <Grid item xs={12}>
          <Groupbox>
            <Formik
              initialValues={{ email: '', onlyActive: false }}
              onSubmit={onSearch}
            >
              {(props) => <UsersFilterSection {...props} />}
            </Formik>
          </Groupbox>
        </Grid>
        <Grid item xs={12}>
          <UsersTable users={filteredUsers} />
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default Users;
